var React = require('react');

function Gre (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1875_3552)","key":0},React.createElement("path",{"d":"M7 4.66634V9.33301H21V4.66634H23.3415C23.9808 4.66634 24.5 5.18551 24.5 5.82484V24.5078C24.5 25.1472 23.9808 25.6663 23.3415 25.6663H4.6585C4.01917 25.6663 3.5 25.1472 3.5 24.5078V5.82484C3.5 5.18551 4.01917 4.66634 4.6585 4.66634H7ZM10.5 19.833H8.16667V22.1663H10.5V19.833ZM10.5 16.333H8.16667V18.6663H10.5V16.333ZM10.5 12.833H8.16667V15.1663H10.5V12.833ZM18.6667 2.33301V6.99967H9.33333V2.33301H18.6667Z","fill":"#733EC8"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1875_3552"},React.createElement("rect",{"width":"28","height":"28","fill":"white"})))]);
}

Gre.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Gre;

Gre.default = Gre;
